import { parseRuntime } from './impl-helper';

export const getIsLoginFactRender = async (params, almanac) => {
    const { variable, current } = await parseRuntime(params, almanac);
    const isLogin = variable?.UID > 0;
    console.log('isLogin', isLogin);
    if (current.port.id === 'is-login-port') {
        return isLogin;
    } else if (current.port.id === 'is-not-login-port') {
        return !isLogin;
    }
    return false;
};
